import React, { useState } from "react";
import { MdCheck } from "react-icons/md";
import { RotatingLines } from "react-loader-spinner";
import { usePlan } from "src/modules/protocols/context";

// import { Container } from './styles';

const SaveButton: React.FC = () => {
  const {
    save,
    plan: { selected, modified },
  } = usePlan();

  const [loading, setLoading] = useState(false);

  function Save() {
    if (!modified) return;
    setLoading(true);
    save().finally(() => setLoading(false));
  }

  return (
    <button
      disabled={!modified}
      onClick={Save}
      className={`h-[32px] min-w-[32px] items-center justify-center rounded-md bg-${loading && !modified ? "zinc" : "green"}-700 px-1.5`}
    >
      {loading ? (
        <RotatingLines strokeColor="#fff" width="15px" />
      ) : modified ? (
        <p className="text-white">SALVAR</p>
      ) : (
        <MdCheck color="#fff" size={16} />
      )}
    </button>
  );
};

export default SaveButton;
